let config;

config = {
    $api_url: "https://api.ganjoor.net",
    trackingId: "1" // or get from environment variables
};

export { config }